import { LoadingSkeleton } from '@components';
import { useAppDispatch, useAppSelector, useScrollToTop } from '@hooks';
import { Box, Pagination, styled } from '@mui/material';
import {
  getSearchOffset,
  getVisibleItemCountInCurrentSection,
  setSearchOffset,
} from '@store/search/search.slice';
import { breakpoints } from '@themes/theme.helpers';

// STYLES
//--------
const PaginationBox = styled(Box)`
  display: flex;
  justify-content: center;
  padding: 16px 0;
  ${breakpoints.up('md')} {
    padding: 40px 0;
  }
`;

// TYPES
//-------

export type SearchResultsPaginationProps = {
  isLoading?: boolean;
  count?: number;
  itemsPerPage?: number;
};

// COMPONENTS
//------------
export const SearchResultsPagination = ({
  isLoading,
  itemsPerPage = 12,
}: SearchResultsPaginationProps) => {
  const scrollToTop = useScrollToTop();
  const dispatch = useAppDispatch();
  const offset = useAppSelector(getSearchOffset);
  const resultCount = useAppSelector(getVisibleItemCountInCurrentSection);
  const pageCount = Math.ceil(resultCount / itemsPerPage);

  const handleChange = (_: any, page: number) => {
    dispatch(setSearchOffset((page - 1) * itemsPerPage));
    scrollToTop();
  };
  const page = offset / itemsPerPage + 1;
  if (isLoading) {
    return <LoadingSkeleton />;
  }
  if (pageCount < 2) {
    return null;
  }
  return (
    <PaginationBox>
      <Pagination
        page={page}
        count={pageCount}
        variant='outlined'
        shape='rounded'
        onChange={handleChange}
        defaultPage={1}
      />
    </PaginationBox>
  );
};
